import { JsonArray, JsonObject, JsonValue, Where, WhereField } from '@/types/crm/configuration/question_conditionals';
import { z } from 'zod';

export const QUESTION_CONDITIONAL_TYPE =
    [
        "equals",
        "contains",
        "not-equals",
        "not-contains",
        "greater-than",
        "greater-than-equals",
        "less-than",
        "less-than-equals",
        "reg-exp"
    ] as const;

export const QUESTION_BASE_TYPE =
    [
        "number",
        "text",
        "list",
        "boolean",
    ] as const;




export const jsonObjectSchema: z.ZodType<JsonObject> = z.record(z.string(), z.any());

export const jsonArraySchema: z.ZodType<JsonArray> = z.lazy(() =>
    z.array(jsonValueSchema)
);

export const jsonValueSchema: z.ZodType<JsonValue> = z.lazy(() =>
    z.union([
        jsonArraySchema,
        jsonObjectSchema,
        z.unknown()
    ])
);

export const whereFieldSchema: z.ZodType<WhereField> = z.record(z.enum(QUESTION_CONDITIONAL_TYPE), jsonValueSchema.optional()) as z.ZodType<WhereField>;

export const whereSchema: z.ZodType<Where> = z.lazy(() =>
    z.intersection(
        z.record(z.string(), z.union([
            z.array(whereSchema),
            whereFieldSchema
        ])),
        z.object({
            and: z.array(whereSchema).optional(),
            or: z.array(whereSchema).optional(),
        })
    )
);
